import moment from 'moment-timezone';
export var relativeToLabel = function relativeToLabel(dateRange, withRounded) {
  if (withRounded === void 0) {
    withRounded = true;
  }

  var value = typeof dateRange.value === 'string' ? parseInt(dateRange.value, 10) : dateRange.value;
  var unitCountLabel = '';
  var suffix = '';

  if (value === 0) {
    if (dateRange.unit === 'day') {
      unitCountLabel = 'Today';
    } else {
      unitCountLabel = "This " + dateRange.unit;
    }
  } else if (value === 1) {
    if (dateRange.unit === 'day') {
      unitCountLabel = 'Yesterday';
    } else {
      unitCountLabel = value + " " + dateRange.unit;
      suffix = 'ago';
    }
  } else if (value > 1) {
    unitCountLabel = value + " " + dateRange.unit + "s";
    suffix = 'ago';
  }

  if (dateRange.round && withRounded) {
    suffix = suffix + " (rounded)";
  }

  if (suffix) {
    return unitCountLabel + " " + suffix;
  }

  return unitCountLabel;
};
export var toCustomDateRange = function toCustomDateRange(dateRange, timezone) {
  if (dateRange.type === 'relative') {
    var value = dateRange.value,
        unit = dateRange.unit,
        round = dateRange.round;
    var now = moment.tz(timezone);
    var start = now.clone().subtract(value, unit + "s");

    if (round) {
      start = start.startOf(unit === 'week' ? 'isoWeek' : unit);
    }

    return {
      type: 'absolute',
      start: start.toISOString(),
      end: now.toISOString()
    };
  }

  return dateRange;
};